import {
  Button,
  Chip,
  CircularProgress,
  Container,
  FormControl,
  Grid,
  Hidden,
  Icon,
  IconButton,
  InputLabel,
  LinearProgress,
  List,
  ListItem,
  MenuItem,
  Paper,
  Select,
  Table,
  TableBody,
  TableCell,
  TablePagination,
  TableRow,
  TextField,
  Tooltip,
  Typography,
} from "@material-ui/core";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import { Alert } from "@material-ui/lab";
import _ from "lodash";
import React from "react";
import { useDispatch } from "react-redux";
import { Redirect } from "react-router-dom";
import { moment } from "../../App";
import bgImg from "../../assets/img/productCurvyLines.png";
import styles from "../../assets/jss/components/headerLinkStyle";
import Footer from "../../common/Footer";
import Header from "../../common/Header";
import { ConvertFromUtcToLocalTimezone } from "../../common/helpers/ConvertFromUtcToLocalTimezone";
import { ErrorMessageResolver } from "../../common/helpers/ErrorMessageResolver";
import { Transliteration } from "../../common/helpers/Transliteration";
import { LOCALE } from "../../properties/Locale";
import { RequestForInformationRepository } from "../../repositories/RequestForInformationRepository";
import { AuthService } from "../auth/AuthService";
const useStyles = makeStyles(styles);

export default function RequestForInformationList() {
  const [redirectTo, setRedirectTo] = React.useState();
  const [loading, setLoading] = React.useState(false);
  const classes = useStyles();
  const [data, setData] = React.useState();
  const [globalFormError, setGlobalFormError] = React.useState();
  const dispatch = useDispatch();
  const [filterData, setFilterData] = React.useState({});
  const theme = useTheme();
  React.useEffect(() => {
    if (AuthService.getCurrentUser() == null) {
      setRedirectTo("/login");
    } else {
      loadData(0, 7, filterData);
    }
  }, []);

  const loadData = (page, size, filterData) => {
    setLoading(true);
    RequestForInformationRepository.getAll(page, size, filterData).then(
      (res) => {
        // console.log(ConvertFromUtcToLocalTimezone.convert(res.data));
        setData(ConvertFromUtcToLocalTimezone.convert(res.data));
        setLoading(false);
      },
      (err) => {
        setGlobalFormError(ErrorMessageResolver.resolve(err));
        setLoading(false);
      }
    );
  };

  const handleChangePage = (event, newPage) => {
    if (loading) return;
    if (!data || !data.size) return;
    loadData(newPage, data.size, filterData);
  };

  const handleChangeFilterData = (name, value) => {
    setFilterData(_.set({ ...filterData }, name, value));
  };

  const handleChangeRowsPerPage = (event) => {
    if (!data || (!data.page && !data.size)) return;
    let rowsPerPage = parseInt(event.target.value, 10);
    loadData(0, rowsPerPage, filterData);
  };

  return (
    <React.Fragment>
      {redirectTo && <Redirect to={redirectTo} push />}
      <div
        style={{
          backgroundImage: "url(" + bgImg + ")",
          backgroundSize: "100% 100%",
          minHeight: "100vh",
          backgroundAttachment: "fixed",
        }}
      >
        {redirectTo && <Redirect to={redirectTo} push />}
        <Header />

        <Container>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <Typography variant="h5">Барања за информации</Typography>
            </Grid>
            {loading && (
              <Grid item xs={12} style={{ paddingBottom: "0px" }}>
                <LinearProgress
                  style={{
                    borderTopRightRadius: "5px",
                    borderTopLeftRadius: "5px",
                  }}
                  color="secondary"
                />
              </Grid>
            )}
            {!loading && (
              <Grid item xs={12} style={{ paddingBottom: "0px" }}>
                <div style={{ height: "4px" }}></div>
              </Grid>
            )}
            <Grid item xs={12}>
              <Paper style={{ marginBottom: "30px" }}>
                <Grid container spacing={3} style={{ padding: "20px" }}>
                  {globalFormError && (
                    <Grid item xs={12}>
                      <Alert severity="error">{globalFormError}</Alert>
                    </Grid>
                  )}

                  <Grid xs={12} md={12} item>
                    <Grid container spacing={2}>
                      <Grid item md={3} xs={12}>
                        <TextField
                          disabled={loading}
                          label="Предмет"
                          size="small"
                          fullWidth
                          value={filterData?.subject ? filterData.subject : ""}
                          onChange={(e) =>
                            handleChangeFilterData(
                              "subject",
                              Transliteration.toUpperCyrilic(e.target.value)
                            )
                          }
                          variant="outlined"
                          onKeyPress={(e) => {
                            if (e.key === "Enter") {
                              loadData(0, 10, filterData);
                            }
                          }}
                        ></TextField>
                      </Grid>
                      <Grid item md={3} xs={12}>
                        <TextField
                          disabled={loading}
                          label="Содржина"
                          size="small"
                          fullWidth
                          value={filterData?.content ? filterData.content : ""}
                          onChange={(e) =>
                            handleChangeFilterData(
                              "content",
                              Transliteration.toUpperCyrilic(e.target.value)
                            )
                          }
                          onKeyPress={(e) => {
                            if (e.key === "Enter") {
                              loadData(0, 10, filterData);
                            }
                          }}
                          variant="outlined"
                        ></TextField>
                      </Grid>
                      <Grid item md={3} xs={12}>
                        <FormControl variant="outlined" fullWidth size="small">
                          <InputLabel id="pickup_way-label">Статус</InputLabel>
                          <Select
                            variant="outlined"
                            value={filterData?.status ? filterData?.status : ""}
                            onChange={(e) => {
                              if (e.target.value) {
                                handleChangeFilterData(
                                  "status",
                                  e.target.value
                                );
                              } else {
                                //delete status from filter data object
                                let newFilterData = _.omit(
                                  filterData,
                                  "status"
                                );
                              }
                            }}
                            label="Статус"
                          >
                            <MenuItem value={""}>{"Сите"}</MenuItem>
                            <MenuItem value={"NEW"}>{"Ново барање"}</MenuItem>
                            <MenuItem value={"COMPLETED"}>
                              {"Завршено барање"}
                            </MenuItem>
                          </Select>
                        </FormControl>
                      </Grid>

                      <Grid item md={3} xs={12}>
                        <Button
                          variant="contained"
                          color="secondary"
                          disabled={loading}
                          size="small"
                          fullWidth
                          onClick={() => loadData(0, 10, filterData)}
                        >
                          {LOCALE.search}
                        </Button>
                      </Grid>
                    </Grid>
                    <Grid item xs={12} sm={12} md={12}>
                      <Hidden smUp>
                        <TablePagination
                          component="div"
                          count={data?.totalElements ? data?.totalElements : 0}
                          rowsPerPage={data?.size || 7}
                          page={data ? data.number : 0}
                          rowsPerPageOptions={[7, 14, 21]}
                          labelRowsPerPage={""}
                          onChangePage={handleChangePage}
                          onChangeRowsPerPage={handleChangeRowsPerPage}
                        />
                      </Hidden>
                      <Hidden xsDown>
                        <TablePagination
                          component="div"
                          count={data?.totalElements ? data?.totalElements : 0}
                          rowsPerPage={data?.size || 7}
                          page={data ? data.number : 0}
                          rowsPerPageOptions={[7, 14, 21]}
                          labelRowsPerPage={LOCALE.lines_per_page}
                          onChangePage={handleChangePage}
                          onChangeRowsPerPage={handleChangeRowsPerPage}
                        />
                      </Hidden>
                    </Grid>
                    <Grid>
                      <Table>
                        <TableBody>
                          <TableRow>
                            <TableCell>
                              <strong>Предмет</strong>
                            </TableCell>
                            <Hidden xsDown>
                              <TableCell>
                                <strong>Содржина од барањето</strong>
                              </TableCell>
                            </Hidden>
                            <Hidden xsDown>
                              <TableCell style={{ textAlign: "center" }}>
                                <strong>{LOCALE.requestDate}</strong>
                              </TableCell>
                            </Hidden>
                            <TableCell style={{ textAlign: "center" }}>
                              <strong>{LOCALE.paymentStatus}</strong>
                            </TableCell>
                            <Hidden xsDown>
                              <TableCell style={{ textAlign: "center" }}>
                                <strong>{LOCALE.status}</strong>
                              </TableCell>
                            </Hidden>
                            <TableCell style={{ textAlign: "center" }}>
                              <strong>{LOCALE.downloadURL}</strong>
                            </TableCell>
                            <TableCell style={{ textAlign: "center" }}>
                              <strong>{LOCALE.preview}</strong>
                            </TableCell>
                          </TableRow>
                        </TableBody>
                        <TableBody>
                          {loading && (
                            <TableRow>
                              <TableCell colSpan={6}>
                                <div
                                  style={{
                                    marginTop: "75px",
                                    marginBottom: "75px",
                                    textAlign: "center",
                                    display: "block",
                                  }}
                                >
                                  <CircularProgress color="secondary" />
                                  <p>
                                    <strong>{LOCALE.searching}</strong>
                                  </p>
                                </div>
                              </TableCell>
                            </TableRow>
                          )}
                          {data &&
                            !loading &&
                            data.content &&
                            data.content.map((item, index) => (
                              <TableRow
                                key={index}
                                style={{
                                  backgroundColor:
                                    index % 2 === 0 ? "#fbfafa" : "white",
                                }}
                              >
                                <TableCell>{item?.subject}</TableCell>
                                <Hidden xsDown>
                                  <TableCell>
                                    <Typography
                                      className="webkitLineClamp2"
                                      style={{
                                        textOverflow: "ellipsis",
                                        overflow: "hidden",
                                        width: "100%",
                                        display: "-webkit-box",
                                        "-webkit-box-orient": "vertical",
                                        "-webkit-line-clamp": "3",
                                      }}
                                    >
                                      {item?.content}
                                    </Typography>
                                  </TableCell>
                                </Hidden>
                                <Hidden xsDown>
                                  <TableCell
                                    style={{ textAlign: "center", width: 150 }}
                                  >
                                    {item.createdDate && item.createdDate
                                      ? moment(item.createdDate).format(
                                          "DD.MM.YYYY HH:mm:ss"
                                        ) + " "
                                      : "N/A"}
                                  </TableCell>
                                </Hidden>
                                <TableCell style={{ textAlign: "center" }}>
                                  {!item.paymentStatus && (
                                    <Chip
                                      label={LOCALE.UNPAID}
                                      color="secondary"
                                      style={{
                                        textTransform: "uppercase",
                                      }}
                                    />
                                  )}
                                  {item.paymentStatus &&
                                    item.paymentStatus === "PAID" && (
                                      <Chip
                                        label={LOCALE.getString(
                                          item.paymentStatus
                                        )}
                                        color="primary"
                                        style={{ textTransform: "uppercase" }}
                                      />
                                    )}
                                  {item.paymentStatus &&
                                    item.paymentStatus === "UNPAID" && (
                                      <Chip
                                        label={LOCALE.UNPAID}
                                        color="secondary"
                                        style={{ textTransform: "uppercase" }}
                                      />
                                    )}
                                  {item.paymentStatus &&
                                    item.paymentStatus ===
                                      "PAYMENT_STATUS_CANCELLED" && (
                                      <Chip
                                        label={LOCALE.getString(
                                          item.paymentStatus
                                        )}
                                        color="secondary"
                                        style={{ textTransform: "uppercase" }}
                                      />
                                    )}
                                  {item.paymentStatus &&
                                    item.paymentStatus ===
                                      "PAYMENT_STATUS_IN_PROCESS" && (
                                      <Chip
                                        label={LOCALE.getString(
                                          item.paymentStatus
                                        )}
                                        color="primary"
                                        style={{ textTransform: "uppercase" }}
                                      />
                                    )}
                                </TableCell>
                                <Hidden xsDown>
                                  <TableCell style={{ textAlign: "center" }}>
                                    <Chip
                                      label={LOCALE.getString(item.status)}
                                      color={
                                        item.status == "SUBMITTED"
                                          ? "success"
                                          : "primary"
                                      }
                                      style={{
                                        textTransform: "uppercase",
                                        width: "150px",
                                      }}
                                    />
                                  </TableCell>
                                </Hidden>
                                <TableCell style={{ textAlign: "center" }}>
                                  {item.paymentStatus === "PAID" &&
                                    item.status === "COMPLETED" && (
                                      <a
                                        href={
                                          "/external/verify/certificate/" +
                                          item.verificationCode
                                        }
                                        target="_blank"
                                      >
                                        <Icon style={{ color: "black" }}>
                                          cloud_download
                                        </Icon>
                                      </a>
                                    )}
                                  {item.paymentStatus === "UNPAID" ? (
                                    <Tooltip title={LOCALE.UNPAID}>
                                      <Icon style={{ color: "black" }}>
                                        money_off
                                      </Icon>
                                    </Tooltip>
                                  ) : (
                                    ""
                                  )}
                                </TableCell>
                                <TableCell style={{ textAlign: "center" }}>
                                  <IconButton
                                    color="secondary"
                                    size="small"
                                    onClick={() => {
                                      setRedirectTo(
                                        "/requestForInformation/" + item.id
                                      );
                                    }}
                                  >
                                    <Tooltip title={LOCALE.open}>
                                      <Icon>open_in_new</Icon>
                                    </Tooltip>
                                  </IconButton>
                                </TableCell>
                              </TableRow>
                            ))}
                        </TableBody>
                        {data && data.content && data.content.length === 0 && (
                          <TableRow>
                            <TableCell colSpan={6}>
                              <Icon
                                style={{
                                  color: "orange",
                                  marginRight: "5px",
                                }}
                              >
                                warning
                              </Icon>
                              <span
                                style={{
                                  lineHeight: "2",
                                  verticalAlign: "top",
                                  fontWeight: "bold",
                                }}
                              >
                                {LOCALE.no_records_found}
                              </span>
                            </TableCell>
                          </TableRow>
                        )}
                      </Table>
                    </Grid>
                  </Grid>
                </Grid>
              </Paper>
            </Grid>
          </Grid>
        </Container>
        <br />
        <br />
      </div>{" "}
      <Footer />
    </React.Fragment>
  );
}
